var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentQuestion)?_c(_vm.questionType,{tag:"component",attrs:{"question":_vm.currentQuestion,"submitAnswer":_vm.chooseAnswer,"selectAnswer":_vm.selectAnswer}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }